import { styled, Typography } from "@mui/material"
import { TransformWrapper as ZPPTransformWrapper } from "react-zoom-pan-pinch"

import { CachedRoundedIcon } from "@l2r-front/l2r-icons"

export const Container = styled("div")(({ theme }) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4),
}))

export const ImageWrapper = styled("div")(() => ({
    width: "100%",
    height: "100%",
    flex: 1,
    alignContent: "center",
}))

export const TransformWrapper = styled(ZPPTransformWrapper)(() => ({
    width: "100%",
    height: "100%",
}))

export const ImageViewer = styled("img")(() => ({
    width: "auto",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
    margin: "auto",
    display: "block",
}))

export const FileIconWrapper = styled("div")(({ theme }) => ({
    width: "100%",
    height: "100%",
    flex: "1 1 0",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(6),
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 16,
}))

export const NoPreviewMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    textAlign: "center",
}))

export const ChangeIcon = styled(CachedRoundedIcon)(() => ({
    marginRight: 2,
}))